/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_FastInputs */

const en_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAST`)
};

const ar_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#سريع`)
};

const bn_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAST`)
};

const de_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAST`)
};

const es_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAST`)
};

const fr_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAST`)
};

const pt_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAST`)
};

const zh_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAST`)
};

const tr_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAST`)
};

const ru_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAST`)
};

const pl_svtag_fast = /** @type {(inputs: Svtag_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FAST`)
};

/**
* | output |
* | --- |
* | "#FAST" |
*
* @param {Svtag_FastInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_fast = /** @type {((inputs?: Svtag_FastInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_FastInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_fast(inputs)
	if (locale === "bn") return bn_svtag_fast(inputs)
	if (locale === "de") return de_svtag_fast(inputs)
	if (locale === "es") return es_svtag_fast(inputs)
	if (locale === "fr") return fr_svtag_fast(inputs)
	if (locale === "pt") return pt_svtag_fast(inputs)
	if (locale === "zh") return zh_svtag_fast(inputs)
	if (locale === "tr") return tr_svtag_fast(inputs)
	if (locale === "ru") return ru_svtag_fast(inputs)
	if (locale === "pl") return pl_svtag_fast(inputs)
	return en_svtag_fast(inputs)
});